export default __webpack_public_path__ + "static/media/jamaican.57370a00.webp";